import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "./api/apiSlice";
import { setupListeners } from "@reduxjs/toolkit/query";
import authReducer from "../features/auth/authSlice";
import workbookcontrolsReducer from "../features/reduxworkbook/WorkbookControllingSlice";
import undoableReducer from "../features/reduxworkbook/WorkbookSlice";

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    auth: authReducer,
    Workbook: undoableReducer,
    workbookcontrols: workbookcontrolsReducer, // updated from workbookControlSlice
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
  devTools: true,
});

setupListeners(store.dispatch);
